const userNumber = {
  heading: 'Your Contact Number',
  type: 'number',
  fvalue: '',
  name: 'userNumber',
};
const userEmail = {
  heading: 'Your Email ID',
  type: 'email',
  fvalue: '',
  name: 'userEmail',
};
const vendorName = {
  heading: 'Vendor Name',
  type: 'text',
  fvalue: '',
  name: 'vendorName',
};

const vendorNumber = {
  heading: 'Vendor Number',
  type: 'number',
  fvalue: '',
  name: 'vendorNumber',
};
const comment = {
  heading: 'Description',
  type: 'textarea',
  fvalue: '',
  name: 'comment',
};
const docid = {
  fvalue: '',
  name: 'docid',
};

// const complaintType = {
//   heading: 'Complaint Type*',
//   type: 'dropdown',
//   fvalue: '',
//   name: 'compType',
// };
const city = {
  heading: 'Select City',
  type: 'dropdown',
  fvalue: '',
  name: 'city',
};
const companyName = {
  heading: 'Select Company name',
  type: 'dropdown',
  fvalue: '',
  name: 'compname',
};

exports.complaintList = {
  'Money taken by vendor but no service provided': {
    issue: 'Complaint against vendor',
    subIssue: 'Money taken Service not provided',
    fields: {
      userNumber,
      userEmail,
      city,
      companyName,
      vendorName,
      vendorNumber,
      comment,
      docid,
    },
  },
  'Vendor was rude': {
    issue: 'Complaint against vendor',
    subIssue: 'Vendor Rude/ Not responding',
    fields: {
      userNumber,
      userEmail,
      city,
      companyName,
      vendorName,
      vendorNumber,
      comment,
      docid,
    },
  },
  'Dissatisfied with services provided by vendor': {
    issue: 'Complaint against vendor',
    subIssue: 'Unhappy with service provided',
    fields: {
      userNumber,
      userEmail,
      city,
      companyName,
      vendorName,
      vendorNumber,
      comment,
      docid,
    },
  },
  // 'App related issue': {
  //   issue: 'Customer services',
  //   subIssue: 'App related query',
  //   fields: { userNumber, userEmail, city, comment },
  // },
  // 'Listing issue': {
  //   issue: 'Customer services',
  //   subIssue: 'Edit listing',
  //   fields: { userNumber, userEmail, city, comment },
  // },
  'Profile related issue': {
    issue: 'Mobile',
    subIssue: 'Edit profile',
    fields: { userNumber, userEmail, city, comment },
  },
  // 'Staff related issue': {
  //   issue: 'Customer service',
  //   subIssue: 'ME/TME complaint ',
  //   fields: { userNumber, userEmail, city, comment },
  // },
  'Any other issue': {
    issue: 'Misc',
    subIssue: 'Misc',
    fields: { userNumber, userEmail, city, comment },
  },
};
